<template>
  <transition name="fade">
    <div class="preview-media" v-if="visible" @click="closePreview">
      <!-- 顶部关闭按钮 -->
      <div class="close-btn" @click="closePreview">×</div>

      <!-- Swiper 容器 -->
      <swiper :options="swiperOptions" ref="swiperContainer">
        <!-- 视频项 -->
        <swiper-slide v-for="(media, index) in mediaList" :key="index">
          <div v-if="media.type === 'video'" class="video-container">
            <video
              class="preview-video"
              playsinline
              webkit-playinline
              x5-playinline
              :src="media.url"
              :poster="media.coverImageUrl || ''"
              controls
              loop
              autoplay
            ></video>
          </div>
          <!-- 图片项 -->
          <div v-else class="image-container">
            <img v-lazy="media.url" alt="预览图片" class="preview-image" />
          </div>
        </swiper-slide>

        <!-- 分页指示器 -->
        <div
          class="swiper-pagination"
          slot="pagination"
          v-if="source == 'album'"
        >
          <div class="swiper-pagination-custom"></div>
        </div>
      </swiper>

      <div class="swiper-pagination-custom" v-if="source != 'album'">
        <span v-if="mediaList[currentIndex] && mediaList[currentIndex].group" class="group-name">
          {{ mediaList[currentIndex].group }}
        </span>
        <span>{{ currentIndex + 1 }} / {{ mediaList.length }}</span>
      </div>
    </div>
  </transition>
</template>

<script>
import VueAwesomeSwiper from "vue-awesome-swiper";

import "swiper/dist/css/swiper.css";
window.Vue.use(VueAwesomeSwiper);
export default {
  name: "PreviewMedia",
  props: {
    mediaList: {
      type: Array,
      required: true, // [{ type: 'image' | 'video', url: 'xxx' }]
    },
    visible: {
      type: Boolean,
      default: false,
    },
    initialIndex: {
      type: Number,
      default: 0,
    },
    source: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      currentIndex: 0, // 当前页面索引

      swiperOptions: {
        loop: false,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        touchStartPreventDefault: true, // 禁止 touchstart 的默认行为，避免滑动后退
        touchMoveStopPropagation: true, // 阻止滑动事件的传播，防止触发浏览器的返回操作
      },
      swiperInstance: null, // 用于存储 Swiper 实例
    };
  },

  computed: {},
  beforeDestroy() {
    if (this.swiperInstance) {
      this.swiperInstance = null;
    }
  },
  watch: {
    visible(val) {
      this.currentIndex = this.initialIndex;
      if (val) {
        // 为了解决产品详情引入预览组件后很多事件没有返回swiper实例导致拿不到索引，不知道哪个傻逼全局引入了swiper，应该是swiper冲突了
        if (this.source == "album") {
          this.swiperOptions.pagination = {
            el: ".swiper-pagination",
            type: "custom",
            renderCustom: (swiper, current, total) => {

              console.log(current,'currentcurrent');
              this.currentIndex = current - 1; // 更新 currentIndex

              return `${
                this.mediaList.length && this.mediaList[current - 1].group
                  ? `<span class="group-name">${
                      this.mediaList[current - 1].group
                    }</span>`
                  : ""
              } <span>${current} / ${total}</span>`;
            },
          };
        } else {
          this.swiperOptions.onSlideChangeStart = (swiper) => {
            this.currentIndex = swiper.activeIndex;
          };
        }
        this.$nextTick(() => {
          // 获取 swiper 实例
          if (this.$refs.swiperContainer) {
            const mySwiper = this.$refs.swiperContainer.swiper;

            this.swiperInstance = mySwiper; // 保证 swiper 实例已赋值
            if (mySwiper) {
              mySwiper.slideTo(this.initialIndex, 0); // 跳转到指定索引
            }
          }
        });
      }
    },
  },

  methods: {
    closePreview() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.preview-media {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.9);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  .close-btn {
    position: absolute;
    top: 32px;
    right: 32px;
    font-size: 56px;
    color: #fff;
    cursor: pointer;
    z-index: 1100;
  }

  .swiper-pagination-custom {
    display: flex;
    justify-content: space-between; // 默认左右对齐
    align-items: center; // 垂直居中
    width: 100%;
    box-sizing: border-box;
    padding: 0 30px;
    font-size: 20px;
    color: white;
    font-weight: bold;
    position: absolute;
    bottom: 12px;
    span {
      color: #fff;
      margin: 0 5px;
      font-size: 22px;
    }

    span:first-child {
      margin-left: 0; // 去除左边间距
    }

    span:last-child {
      margin-right: 0; // 去除右边间距
    }
  }

  .swiper-container {
    width: 100%;
    height: 100%;

    .swiper-slide {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .image-container {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        .preview-image {
          max-width: 100%;
          max-height: 100%;
        }
      }

      .video-container {
        width: 88%;
        display: flex;
        align-items: center;
        justify-content: center;

        .preview-video {
          max-width: 100%;
          object-fit: contain;
        }
      }
    }

    .swiper-pagination {
      position: absolute;
      bottom: 20px;
      width: 100%;
      text-align: center;
      font-size: 20px;
      color: white;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
